import { Tooltip } from '@bfe/moly';
import { TelegramLogoIcon } from '@bfe/moly-icons';
import { RTLSkipEnd, RTLSkipStart } from '@bybit/rtl-plugin';
import { useEffect, useState } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';
import { queryBindAppStatus } from '@/services/bindApp';
import { BIND_APP_STATUS, THIRD_APP_LIST } from '@/utils/pageConfig/thirdApp';
import { sensors } from '@/utils/skynet';

import TgBindBtn from './components';

const StatusNode = ({ status, name }: { status: boolean; name: string }) => {
  const [$t] = useI18nContext();

  if (!status) {
    return $t('Not Set');
  }

  return (
    <div className="bind-third-app-icons">
      <img src={THIRD_APP_LIST['telegram']} alt="telegram" key="telegram" />
      {name}
    </div>
  );
};

const SubText = () => {
  const [$t] = useI18nContext();

  useEffect(() => {
    sensors?.exposure?.({
      page_name: 'AccountSecurityView',
      button_name: 'howtounlink_bn',
      model_name: 'show_linkaccount_model',
    });
  }, []);

  return (
    <div className="bind-third-app-sub-text">
      {$t('securityItemAccountBindDesc')}
      <RTLSkipStart></RTLSkipStart>
      <Tooltip
        title={$t('unlinkTelegramDesc')}
        trigger="hover"
        placement="top"
        onOpenChange={(isShow) => {
          if (isShow) {
            sensors?.click?.({
              page_name: 'AccountSecurityClick',
              button_name: 'howtounlink_bn',
              model_name: 'show_linkaccount_model',
            });
          }
        }}
      >
        <span className="bind-third-app-sub-text-unlink-tip">
          {$t('howToUnlink')}
        </span>
      </Tooltip>
      <RTLSkipEnd></RTLSkipEnd>
    </div>
  );
};

const ThirdAccountBindEntry = () => {
  const [$t] = useI18nContext();
  const [loading, setLoading] = useState(true);
  const [bindTgStatus, setBindTgStatus] = useState(false);
  const [tgName, setTgName] = useState('');

  // 构建tg名称
  const onSetTgName = (
    username: string,
    first_name: string,
    last_name: string,
  ) => {
    const userName = username ? `@${username}` : '';
    const firstName = first_name ? `${first_name} ` : '';
    const lastName = last_name ? `${last_name}` : '';
    const fullName = `${firstName}${lastName}`;

    setTgName(userName || fullName);
  };

  // 绑定成功回调
  const onBindSuccess = (
    username: string,
    first_name: string,
    last_name: string,
  ) => {
    onSetTgName(username, first_name, last_name);
    setBindTgStatus(true);
  };

  // 解绑成功回调
  const onUnBindSuccess = () => {
    setTgName('');
    setBindTgStatus(false);
  };

  useEffect(() => {
    setLoading(true);
    // 获取绑定状态
    queryBindAppStatus()
      .then((res) => {
        setBindTgStatus(res?.result?.bind_status === BIND_APP_STATUS.BOUND);

        onSetTgName(
          res?.result?.username || '',
          res?.result?.first_name || '',
          res?.result?.last_name || '',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!loading) {
      sensors?.exposure?.({
        page_name: 'AccountSecurityView',
        button_name: bindTgStatus ? 'unlink_bn' : 'settings_bn',
        model_name: 'show_linkaccount_model',
      });
    }
  }, [loading, bindTgStatus]);

  return (
    <AccountBasicItem
      icon="telegram"
      molyIcon={<TelegramLogoIcon />}
      text={$t('securityItemAccountBindTitle')}
      subText={<SubText />}
      status={bindTgStatus}
      showStatusIcon={!bindTgStatus}
      statusNode={<StatusNode status={bindTgStatus} name={tgName} />}
      operation={
        <>
          <TgBindBtn
            status={bindTgStatus}
            onBindSuccess={onBindSuccess}
            onUnbindSuccess={onUnBindSuccess}
          />
        </>
      }
    />
  );
};

export default ThirdAccountBindEntry;
